import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.index = -1
    this.onKey = this.onKey.bind(this)
    document.addEventListener("keydown", this.onKey)
    if (sessionStorage.getItem("ps-focus-search")) {
      sessionStorage.removeItem("ps-focus-search")
      this.searchField()?.focus()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKey)
  }

  onKey(event) {
    if (this.isTyping(event)) {
      if (event.key === "Escape") event.target.blur()
      return
    }
    if (event.metaKey || event.ctrlKey || event.altKey) return

    if (event.key === "/") {
      event.preventDefault()
      this.focusSearch()
    } else if (event.key === "j") {
      event.preventDefault()
      this.move(1)
    } else if (event.key === "k") {
      event.preventDefault()
      this.move(-1)
    } else if (event.key === "c") {
      event.preventDefault()
      this.copyFocused()
    } else if (event.key === "?" ) {
      event.preventDefault()
      this.toggleHelp()
    } else if (event.key === "Enter") {
      this.openFocused()
    } else if (event.key === "Escape") {
      document.getElementById("keyboard-help")?.close()
    }
  }

  isTyping(event) {
    const tag = event.target.tagName
    return event.target.isContentEditable || tag === "INPUT" || tag === "TEXTAREA" || tag === "SELECT"
  }

  searchField() {
    return document.querySelector("[data-shortcut-search]")
  }

  focusSearch() {
    const field = this.searchField()
    if (field) {
      field.focus()
      field.select?.()
      return
    }
    sessionStorage.setItem("ps-focus-search", "1")
    window.Turbo ? window.Turbo.visit("/phrases") : (window.location.href = "/phrases")
  }

  rows() {
    return [...document.querySelectorAll("[data-phrase-row]")]
  }

  move(delta) {
    const rows = this.rows()
    if (!rows.length) return
    if (this.index < 0) this.index = delta > 0 ? 0 : 0
    else this.index = Math.min(Math.max(this.index + delta, 0), rows.length - 1)
    rows.forEach((row, index) => {
      if (index === this.index) row.setAttribute("data-focused", "")
      else row.removeAttribute("data-focused")
    })
    rows[this.index]?.scrollIntoView({ block: "nearest" })
  }

  copyFocused() {
    const row = this.rows()[this.index]
    row?.querySelector("[data-controller='copy-phrase']")?.click()
  }

  openFocused() {
    const row = this.rows()[this.index]
    const href = row?.dataset?.phraseUrl
    if (href) window.Turbo ? window.Turbo.visit(href) : (window.location.href = href)
  }

  toggleHelp() {
    const dialog = document.getElementById("keyboard-help")
    if (!dialog) return
    if (dialog.open) dialog.close()
    else dialog.showModal()
  }
}
